/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-insurances
 * crm-screener-insurances
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { VisualReference } from './VisualReference';
import {
    VisualReferenceFromJSON,
    VisualReferenceFromJSONTyped,
    VisualReferenceToJSON,
    VisualReferenceToJSONTyped,
} from './VisualReference';
import type { GgFunctionScoreScore } from './GgFunctionScoreScore';
import {
    GgFunctionScoreScoreFromJSON,
    GgFunctionScoreScoreFromJSONTyped,
    GgFunctionScoreScoreToJSON,
    GgFunctionScoreScoreToJSONTyped,
} from './GgFunctionScoreScore';
import type { GgFunctionScorePredictedScore } from './GgFunctionScorePredictedScore';
import {
    GgFunctionScorePredictedScoreFromJSON,
    GgFunctionScorePredictedScoreFromJSONTyped,
    GgFunctionScorePredictedScoreToJSON,
    GgFunctionScorePredictedScoreToJSONTyped,
} from './GgFunctionScorePredictedScore';
import type { FunctionScoreAction } from './FunctionScoreAction';
import {
    FunctionScoreActionFromJSON,
    FunctionScoreActionFromJSONTyped,
    FunctionScoreActionToJSON,
    FunctionScoreActionToJSONTyped,
} from './FunctionScoreAction';

/**
 * 
 * @export
 * @interface GgFunctionScore
 */
export interface GgFunctionScore {
    /**
     * 
     */
    action: FunctionScoreAction;
    /**
     * 
     */
    score: GgFunctionScoreScore | null;
    /**
     * 
     */
    predicted_score?: GgFunctionScorePredictedScore | null;
    /**
     * 
     */
    readonly reasoning?: string | null;
    /**
     * 
     */
    readonly visual_references?: Array<VisualReference>;
}



/**
 * Check if a given object implements the GgFunctionScore interface.
 */
export function instanceOfGgFunctionScore(value: object): value is GgFunctionScore {
    if (!('action' in value) || value['action'] === undefined) return false;
    if (!('score' in value) || value['score'] === undefined) return false;
    return true;
}

export function GgFunctionScoreFromJSON(json: any): GgFunctionScore {
    return GgFunctionScoreFromJSONTyped(json, false);
}

export function GgFunctionScoreFromJSONTyped(json: any, ignoreDiscriminator: boolean): GgFunctionScore {
    if (json == null) {
        return json;
    }
    return {
        
        'action': FunctionScoreActionFromJSON(json['action']),
        'score': GgFunctionScoreScoreFromJSON(json['score']),
        'predicted_score': json['predicted_score'] === undefined ? undefined : json['predicted_score'] === null ? null : GgFunctionScorePredictedScoreFromJSON(json['predicted_score']),
        'reasoning': json['reasoning'] === undefined ? undefined : json['reasoning'] === null ? null : json['reasoning'],
        'visual_references': json['visual_references'] == null ? undefined : ((json['visual_references'] as Array<any>).map(VisualReferenceFromJSON)),
    };
}

export function GgFunctionScoreToJSON(json: any): GgFunctionScore {
    return GgFunctionScoreToJSONTyped(json, false);
}

export function GgFunctionScoreToJSONTyped(value?: Omit<GgFunctionScore, 'reasoning'|'visual_references'> | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'action': FunctionScoreActionToJSON(value['action']),
        'score': GgFunctionScoreScoreToJSON(value['score']),
        'predicted_score': GgFunctionScorePredictedScoreToJSON(value['predicted_score']),
    };
}

